import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilService } from '../services/util/util.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActionSheetController, AlertController, LoadingController, MenuController, ModalController, PopoverController } from '@ionic/angular';
import { ScrollDetail } from '@ionic/core';


@Component({
  selector: 'app-notification',
  templateUrl: './notification.page.html',
  styleUrls: ['./notification.page.scss'],
})
export class NotificationPage implements OnInit {


  baseUrl: any = '';
  provision_key: any = '';
  client_id: any = '';
  client_secret: any = '';
  grant_type: any = '';
  authUrl: any = '';
  load: boolean = false;
  token: any;
  hasil: any;
  user: any;

  leadw: any = {};
  lwait: any;
  fractionSize;

  dibaca: any = {};
  dbc: any = {};

  constructor(
    public menuCtrl: MenuController,
    public route: Router,
    public http: HttpClient,
    public loadingctrl: LoadingController,
    public alertctrl: AlertController,
    public util: UtilService,
    public activatedRoute: ActivatedRoute,
    public modalController: ModalController,
    public popoverController: PopoverController,
    public actionSheetController: ActionSheetController
  ) {
    this.baseUrl = environment.restURL.baseUrl;
    this.provision_key = environment.restURL.provision_key;
    this.client_id = environment.restURL.client_id;
    this.client_secret = environment.restURL.client_secret;
    this.grant_type = environment.restURL.grant_type;
    this.authUrl = environment.restURL.authUrl;
  }

  ngOnInit() {
    this.token = localStorage.getItem('usertoken') || '';
    this.user = JSON.parse(localStorage.getItem('user') || '');
    // this.res()
  }

  ionViewWillEnter(){
    this.res();
  }

  fungsilogout() {
    this.util.showToast('Sesi anda berakhir, Silahkan Login Kembali', 'success', 'bottom');
    localStorage.removeItem('usertoken');
    localStorage.removeItem('user');
    this.route.navigate(['./login']);
  }

  res() {
    let hd = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.token
    };
    this.load = true;
    this.http.get(this.baseUrl + '/notification', { headers: hd })
      .subscribe((data) => {
        this.leadw = data;
        console.log('all', this.leadw);
        if (this.leadw.error == 0) {
          this.load = false;
          if (this.leadw.total == 0){
            this.lwait = null;
          } else {
            // setTimeout(() => {
            this.lwait = this.leadw.rows;
            // }, 1000);
          }
          console.log('data',this.lwait);
        } else {
          this.load = false;
          this.util.showToast(this.leadw.message, 'success', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        if (error.error.error == 'invalid_token' || error.status == 401) {
          this.fungsilogout();
        } else {
          this.util.showToast(error.error.message, 'danger', 'bottom');
        }
      });
  }

  // detail(p){
  //   console.log(p);
  //   if (p == 'group'){

  //   }
  // }

  read(p){
    console.log('param',p);
    let hd = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.token
    };
    this.http.request('put',this.baseUrl+'notification/'+p.id, {headers: hd})
      .subscribe((data) => {
        this.dibaca = data;
        console.log('dibaca', this.dibaca);
        // if (this.dibaca.error == 0) {
        //     this.util.showToast(this.dibaca.message, 'success', 'bottom');
        //   } else {
        //     this.util.showToast('Terjadi Kesalahan', 'danger', 'bottom');
        //   }
        //   console.log('dibaca',this.dibaca);
      }, (error) => {
        console.log('error', error);
        if (error.error.error == 'invalid_token' || error.status == 401) {
          this.fungsilogout();
        } else {
          this.util.showToast(error.statusText, 'danger', 'bottom');
        }
      });
  }

  async filter() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Filter berdasarkan',
      cssClass: 'my-custom-class',
      buttons: [{
        text: 'Semua',
        handler: () => {
          // this.interested = '';
          // this.leadResponse();
        }
      }, {
        text: 'Leads',
        handler: () => {
          // this.interested = true;
          // this.leadResponse();
        }
      },{
        text: 'Prospect',
        handler: () => {
          // this.interested = false;
          // this.leadResponse();
        }
      },{
        text: 'Partner',
        handler: () => {
          // this.interested = false;
          // this.leadResponse();
        }
      }]
    });
    await actionSheet.present();
    const { role, data } = await actionSheet.onDidDismiss();
    console.log('onDidDismiss resolved with role and data', role, data);
  }

}
 